import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Dropdown, 
    Space,
    Modal,
    Input,
    Form,
    Select,
} from 'antd';
import toast from 'react-hot-toast';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { useNavigate } from 'react-router-dom';
import { formatDate, getUserRole } from '../../Utils/Common';

const { Item } = Form;
const { Search } = Input;
const { Option } = Select;
const { confirm } = Modal;

const TaskManager = () => {
    const navigate = useNavigate();
    const role_name = getUserRole();
    const [addForm] = Form.useForm();
    const [addVisible, setAddVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState('');
    const [statusId, setStatusId] = useState('');
    const [filterConfig, setFilterConfig] = useState({
        search: '',
        type: '',
        manager_id: '',
        page: 1,
    })
    const [managerData, setManagerData] = useState([])

    const { callPost, loading } = usePostRequest(()=>{
        fetchTaskManagerData();
        setAddVisible(false);
        setStatusId('');
    });
    
    const stutus_data = [
        {
            name: 'All Status',
            value: '',
        },
        {
            name: 'In-progress',
            value: 'in-progress',
        },
        {
            name: 'To Do',
            value: 'to do',
        },
        {
            name: 'Done',
            value: 'done',
        },
        {
            name: 'Cancelled',
            value: 'cancelled',
        },
    ];

    const priority = [
        {
            name: 'All Priority',
            value: '',
        },
        {
            name: 'High',
            value: 'high',
        },
        {
            name: 'Medium',
            value: 'medium',
        },
        {
            name: 'Low',
            value: 'low',
        },
    ];

    const handleAddOk = () => {
        addForm.validateFields().then(values => {
            const newValues = {
                task_manager_id: statusId,
                status: values.status,
            }

            callPost(
                "task_managers/change_status", 
                newValues,
                false
            );
        }).catch(errorInfo => {
          toast.error('Validation Failed:', errorInfo);
        });
    };

    const handleAddCancel = () => {
        addForm.resetFields();
        setAddVisible(false);
        setStatusId('');
    };

    function ActionBtn(row) {
        const items = [
            {
                label: (
                    <div 
                        onClick={() => {
                            setAddVisible(true);
                            setStatusId(row.row.id);
                        }}
                    >
                        Change Status
                    </div>
                ),
                key: '1',
            },
            ...(role_name === "Administrator" 
                ? [
                    {
                        label: (
                            <div 
                                onClick={() => navigate('/task-manager/edit/' + row.row.id)}
                            >
                                Edit
                            </div>
                        ),
                        key: '2',
                    },
                    {
                        label: (
                            <div style={{color: 'red'}} onClick={()=>showDeleteConfirm(row.row.id)}>
                                Delete
                            </div>
                        ),
                        key: '3',
                    }
                ] : []
            )
        ];

        return (
            <>
                <span className='center'>
                    <Dropdown
                        menu={{
                        items,
                        }}
                        trigger={['click']}
                    >
                        <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
                            <Space>
                                <MoreVert />
                            </Space>
                        </div>
                    </Dropdown>
                </span>
            </>
        );
    }

    async function fetchTaskManagerData  () {
        setIsLoading(true)
        const response = await UseGetRequest("task_managers/get", filterConfig);
        if (response?.data) {
            const data = response?.data?.data?.map((info) => ({
                ...info,
                due_date: formatDate(info.due_date)
            }))
            setManagerData(data);
            setPageSize(response?.data?.size)
        } else {
            setManagerData([])
            setPageSize('')
        }
        setIsLoading(false);
    }

    const showDeleteConfirm = (id) => {
        confirm({
            title: 'Do you want to permanently remove this Task Manager?',
            icon: <ExclamationCircleFilled/>,
            content: 'This action cannot be undone.',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            okButtonProps: {
                className: 'custom-yes-button',
            },
            cancelButtonProps: {
                className: 'custom-no-button',
            },
            confirmLoading: loading,
            onOk() {
                callPost(
                "task_managers/delete", 
                {task_manager_id: id},
                false
                );
            },
        });
    }; 

    const handleSearchChange = (e) => {
        setFilterConfig((prev) => (
        {
            ...prev,
            search: e || '',
            page: 1,
        }
        ));
    };

    const filterStatus = (e) => {
        setFilterConfig((prev) => (
          {
            ...prev,
            status:  e
          }
        ));
    };

    const filterPriority = (e) => {
        setFilterConfig((prev) => (
            {
                ...prev,
                priority:  e
            }
        ));
    };

    const handleEmpty = (e) => {
        if(e.target.value === ''){
        setFilterConfig((prev) => (
            {
            ...prev,
            search: e.target.value || '',
            page: 1,
            }
        ));
        }
    };

    const handleTableChange = (pagination) => {
        setFilterConfig((prev) => ({
            ...prev,
            page: parseInt(pagination.current),
            page_size: pagination.pageSize
        }));
    };

    useEffect(() => {
        fetchTaskManagerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterConfig]);

    return (
        <Layout className='page'>
            <Navbar navKey={'task_manager_nav'}/>
            <Layout className='content-container overflow-y'>
                <Row className='custom-padding responsive-tab-inline'>
                    <Col span={9} className='header-container'>
                        TASK MANAGER
                    </Col>
                    <Col span={15} className='mt-2 responsive-tab-width' align='end'>
                        <Space className='responsive-inline'> 
                            {
                                role_name === "Administrator"  && (
                                    <Button 
                                        className='button-color responsive-header-btn' 
                                        onClick={() => navigate('/task-manager/add/')} 
                                        type="primary"
                                    >
                                        + Add Task
                                    </Button>
                                )
                            }
                        </Space>
                    </Col>
                </Row>
                <Row>
                    <Space className='responsive-inline excel-row'>
                        <Search
                            placeholder="Search..."
                            size='medium'
                            onSearch={(e)=>handleSearchChange(e)}
                            onChange={(e)=>handleEmpty(e)}
                            className='responsive-header-input'
                        /> 
                        <Select 
                            placeholder="Select a Status" 
                            showSearch
                            style={{width:'15vw'}}
                            onChange={(e) => filterStatus(e)}
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {stutus_data.map((option) => (
                                <Option key={option.value} value={option.value}>{option.name}</Option>
                            ))}
                        </Select>     
                        <Select 
                            placeholder="Select a Priority" 
                            showSearch
                            style={{width:'15vw'}}
                            onChange={(e) => filterPriority(e)}
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {priority.map((option) => (
                                <Option key={option.value} value={option.value}>{option.name}</Option>
                            ))}
                        </Select>        
                    </Space>
                </Row>
                <Row className='page-content'>
                    <Col span={24} className='responsive-overflow-auto'>
                        <AntDTable
                            tableHeaders={[
                                "Personnel",
                                "Property Name",
                                "Category Name",
                                "Task Status",
                                "Priority",
                                "Due Date",
                            ]}
                            headerSelector={[
                                "personnel_name",
                                "property_name",
                                "category_name",
                                "status",
                                "priority",
                                "due_date",
                            ]}
                            tableData={managerData}
                            ActionBtn={(row) => ActionBtn(row)}
                            withAction={true}
                            loading={isLoading}
                            tablePages={10}
                            handleTableChange={handleTableChange}
                            filterConfig={filterConfig}
                            totalSize={pageSize}
                            isSearch={true}
                        />
                    </Col>
                </Row>
                <Modal
                    title="Change Status"
                    confirmLoading={loading}
                    open={addVisible}
                    onOk={handleAddOk}
                    onCancel={handleAddCancel}
                    okText="Save"
                    maskClosable={false}
                >
                    <Form 
                        form={addForm} 
                        layout="vertical"
                    >
                       <Item
                            label="Status"
                            name="status"
                            rules={[{ required: true, message: 'Please enter your Status!' }]}
                        >
                            <Select 
                                placeholder="Select a Status" 
                                showSearch
                                filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {stutus_data.map((option) => (
                                    <Option key={option.value} value={option.value}>{option.name}</Option>
                                ))}
                            </Select>
                        </Item>
                    </Form>
                </Modal>
            </Layout>
        </Layout>
    )
}

export default TaskManager
